import { RootState } from '../app/store';

export function selectSelectedItemCartId(state: RootState) {
  return state.dialog.selectedItemCartId;
}
